module.exports = __webpack_public_path__ + "media/application/images/2023/06_still-925x520-4a0cfb5f9723322ad0547078fc20ebe7.png";